import type { SVGProps } from "react";

export function IconBlackThreeArrowsAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15 3H21V9L18 6L15 3Z" fill="#23232C" />
      <path
        d="M3 21L18 6M21 3H15L21 9V3Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M21 14H15L18 17L21 20V14Z" fill="#23232C" />
      <path
        d="M14 21L18 17M15 14H21V20L15 14Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M10 3H4L7 6L10 9V3Z" fill="#23232C" />
      <path
        d="M3 10L7 6M4 3H10V9L4 3Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
